export const EmptyFixtureCell = () => (
  <div className="flex h-full w-full items-center justify-center rounded-md bg-neutral-100 text-xs text-neutral-500">
    /
  </div>
);
